'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isUseNewSmartlockApi = isUseNewSmartlockApi;
exports.recordLoginStart = recordLoginStart;
exports.getUrlParameterByName = getUrlParameterByName;
exports.getDecodedUrlParameterByName = getDecodedUrlParameterByName;
function getDevice(ua) {
    var orientation = 'portrait';
    if (typeof window.orientation === 'number') {
        if (window.orientation === 90 || window.orientation === -90) orientation = 'landscape';
    } else if (window.matchMedia('(orientation: portrait)').matches) orientation = 'portrait';else if (window.matchMedia('(orientation: landscape)').matches) orientation = 'landscape';
    var width = orientation === 'portrait' ? window.screen.width : window.screen.height;

    if (/windows\s(?!phone)|macintosh/i.test(ua)) {
        return 'pc';
    } else if (width < 640) {
        return 'mobile';
    } else if (width >= 640) {
        return 'tablet';
    } else {
        return 'unknown';
    }
}

// 判断浏览器是否支持SmartLock功能
function isSmartLockSupport() {
    if (navigator.credentials && window.location.protocol === 'https:') {
        var ua = navigator.userAgent;
        var raw = ua.match(/Chrom(e|ium)\/([0-9]+)\./);
        var version = raw ? parseInt(raw[2], 10) : false;
        if (+version >= 51 && (/android/i.test(ua) || getDevice(ua) === 'pc')) {
            return true;
        }
    }
    return false;
}

var isSmartLockSupported = exports.isSmartLockSupported = isSmartLockSupport();

function isUseNewSmartlockApi() {
    var ua = navigator.userAgent;
    var raw = ua ? ua.match(/Chrom(e|ium)\/([0-9]+)\./) : false;
    var version = raw ? parseInt(raw[2], 10) : false;
    return +version >= 64;
}

// 线下环境
// export const DEVURL = {
//     havanaEmbedJs: 'https://assets.daily.taobao.net/g/tb/login/0.2.5/havanalogin/js/mini-login-embedder-min.js',
//     havanaIframeUrl: 'https://passport.daily.aliexpress.com/mini_login.htm',
//     havanaLoginCheckUrl: 'https://passport.daily.aliexpress.com/newlogin/login.do?fromSite=4',
//     tbSessionApplyStUrl: 'https://passport.daily.alibaba.com/apply_st.htm',
//     tbSessionMiniApplyStUrl: 'https://passport.daily.alibaba.com/mini_apply_st.js',
//     emailVerificationUrl: 'https://passport.daily.aliexpress.com/ac/confirm_email.htm?from_site=13',
//     activeUrl: 'https://passport.daily.aliexpress.com/member/request_dispatcher.htm?from=ACTIVATION&_token='
// };

// 线上环境
// export const PROURL = {
//     havanaEmbedJs: 'https://aeis.alicdn.com/vip/login/0.5.18/havanalogin/js/mini-login-embedder-min.js',
//     havanaIframeUrl: 'https://passport.aliexpress.com/mini_login.htm',
//     havanaLoginCheckUrl: 'https://passport.aliexpress.com/newlogin/login.do?fromSite=4',
//     tbSessionApplyStUrl: 'https://passport.alibaba.com/apply_st.htm',
//     tbSessionMiniApplyStUrl: 'https://passport.alibaba.com/mini_apply_st.js',
//     emailVerificationUrl: 'https://passport.aliexpress.com/ac/confirm_email.htm?from_site=13',
//     activeUrl: 'https://passport.aliexpress.com/member/request_dispatcher.htm?from=ACTIVATION&_token='
// };

// 记录开始登录事件
function recordLoginStart(aeLoginPattern, locale) {
    if (typeof aeLoginPattern === 'undefined' || aeLoginPattern === null || aeLoginPattern.indexOf('martLock') === -1) {
        aeLoginPattern = 'common';
    }
    var url = 'https://login.aliexpress.com/statistics/loginStart.htm';
    var startTime = new Date();
    url = url + '?locale=' + locale.replace('-', '_') + '&startTime=' + startTime.getTime() + '&pattern=' + aeLoginPattern; // eslint-disable-line
    if (window.dmtrack_pageid) {
        url = url + '&pageId=' + window.dmtrack_pageid; // eslint-disable-line
    }
    new Image().src = url;
}

/**
 * Temporary method to log cross-origin security issues
 * Sends error stack trace to RedCode
 *
 * @param functionName
 * @param error
 * @private
 */
// export function logError(functionName, error) {

// }

function getUrlParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&'); // eslint-disable-line
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    var results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return results[2].replace(/\+/g, ' ');
}

function getDecodedUrlParameterByName(name, url) {
    return decodeURIComponent(getUrlParameterByName(name, url));
}